import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/for-wedding-planners";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/for-wedding-planners")({
  head: SEO["/for-wedding-planners"],
  component: () => <ContentPage path="/for-wedding-planners" body={body} />,
});
